var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"website","src":"https://thirsty-wright-cae0f8.netlify.app/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }